var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useLanguage } from '@base/LanguageProvider';
import { DocumentType } from '@common/api';
import SelectInput from '@shared/input/SelectInput';
import TextArea from '@shared/input/TextArea';
import TextInput from '@shared/input/TextInput';
//Components
import Manager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import ModalFooter from '@shared/modal/ModalFooter';
import ModalHeader from '@shared/modal/ModalHeader';
import { FormFieldErrorHelp } from '@styled/Form';
import { ModalBody } from '@styled/Modal';
import React from 'react';
import { useCreateDocument, useDocuments, useUpdateDocument } from '@data/document/documentActions';
var DocumentModal = function (props) {
    var _a, _b, _c, _d;
    var L = useLanguage().L;
    var documents = useDocuments();
    var createDocument = useCreateDocument();
    var updateDocument = useUpdateDocument();
    var typeName = DocumentType[props.type].toLowerCase();
    var documentTemplate = props.document
        ? __assign({}, props.document) : {
        title: '',
        description: '',
        ParentId: (_a = props.ParentId) !== null && _a !== void 0 ? _a : null,
        config: '{}',
        type: props.type,
        gridLocked: false,
    };
    var _e = __read(React.useState(documentTemplate), 2), document = _e[0], setDocument = _e[1];
    var _f = __read(React.useState({}), 2), invalid = _f[0], setInvalid = _f[1];
    var title = 'id' in document ? L('Editing') + ' ' + typeName + ' ' + document.title : L('New') + ' ' + typeName;
    var possibleParents = (_d = (_c = (_b = documents === null || documents === void 0 ? void 0 : documents.data) === null || _b === void 0 ? void 0 : _b.filter(function (f) { return f.type === DocumentType.FOLDER; })) === null || _c === void 0 ? void 0 : _c.map(function (f) { return ({ value: f.id, label: f.title }); })) !== null && _d !== void 0 ? _d : [];
    possibleParents.push({ value: null, label: 'Root' });
    var validate = function () {
        var _invalid = {};
        if (!document.title) {
            _invalid.title = 'You must enter a title for the ' + typeName;
        }
        //documentstodo
        if (document.type === DocumentType.FOLDER && document.ParentId) {
            _invalid.ParentId = "Folders can't have parents";
        }
        //documentstodo
        if (document.type === DocumentType.REPORT && !document.ParentId) {
            _invalid.ParentId = 'You must select a parent folder for the report';
        }
        return _invalid;
    };
    var changeHandler = function (e) {
        var propName = e.target.name;
        var documentCopy = __assign({}, document);
        if (propName === 'ParentId') {
            if (e.target.value === null) {
                documentCopy[propName] = null;
            }
            else {
                documentCopy[propName] = Number(e.target.value);
            }
        }
        else {
            documentCopy[propName] = e.target.value;
        }
        setDocument(documentCopy);
    };
    var save = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _invalid, options;
        return __generator(this, function (_a) {
            e.preventDefault();
            _invalid = validate();
            if (Object.keys(_invalid).length) {
                setInvalid(_invalid);
                return [2 /*return*/];
            }
            options = {
                onSuccess: function () {
                    Manager.closeModal();
                },
                onError: function (error) {
                    if (error instanceof Error) {
                        setInvalid(__assign(__assign({}, invalid), { general: error.message }));
                    }
                },
            };
            if ('id' in document) {
                updateDocument.mutate(document, options);
                return [2 /*return*/];
            }
            createDocument.mutate(document, options);
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(Modal, { width: 600 },
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", { onSubmit: save },
                React.createElement(TextInput, { label: L('Title'), value: document.title, name: "title", onChange: changeHandler, invalidString: invalid.title, bottomMargin: true }),
                props.type === DocumentType.REPORT && (React.createElement(SelectInput, { name: "ParentId", value: document.ParentId, label: L('Folder'), onChange: changeHandler, options: possibleParents, invalidString: invalid.ParentId, bottomMargin: true })),
                React.createElement(TextArea, { label: L('Description'), name: "description", value: document.description || '', onChange: changeHandler }),
                invalid.general && (React.createElement(FormFieldErrorHelp, { style: { marginTop: '10px' } }, invalid.general)))),
        React.createElement(ModalFooter, { done: save, loading: createDocument.isLoading || updateDocument.isLoading })));
};
export default DocumentModal;
